// Indonesian month names
const ID_MONTHS = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

/**
 * Format any date-like value to "2 Mei 2026 at 07:27 AM WIB" (Asia/Jakarta).
 */
export function formatWIB(value) {
  if (!value) return "—";
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return String(value);

  // Convert to WIB (UTC+7) by adding the offset to the UTC time
  const wibMs = d.getTime() + 7 * 60 * 60 * 1000;
  const w = new Date(wibMs);

  const day = w.getUTCDate();
  const month = ID_MONTHS[w.getUTCMonth()];
  const year = w.getUTCFullYear();
  let hours = w.getUTCHours();
  const minutes = String(w.getUTCMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  if (hours === 0) hours = 12;
  const hh = String(hours).padStart(2, "0");
  return `${day} ${month} ${year} at ${hh}:${minutes} ${ampm} WIB`;
}
